import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { apiInstance } from "../api/api";
import { useUser } from "../UserContext";

const FinancialYearContext = createContext();

export const useFinancialYear = () => useContext(FinancialYearContext);

export const FinancialYearProvider = ({ children }) => {
  const { user } = useUser();
  const [activeFY, setActiveFY] = useState(null);
  const [loadingFY, setLoadingFY] = useState(true);
  const [financialYearError, setFinancialYearError] = useState(null);

  const refreshActiveFY = useCallback(async () => {
    if (!user) {
      setLoadingFY(false);
      return null;
    }
    setLoadingFY(true);
    setFinancialYearError(null);
    try {
      const response = await apiInstance.get("/financial-years/active/");
      setActiveFY(response.data);
      return response.data;
    } catch (error) {
      setActiveFY(null);
      setFinancialYearError(
        error?.response?.data?.detail || "Unable to load the active financial year."
      );
      return null;
    } finally {
      setLoadingFY(false);
    }
  }, [user]);

  useEffect(() => {
    refreshActiveFY();
  }, [refreshActiveFY]);

  // useEffect(() => {
  //   apiInstance.get("/financial-years/active/")
  //     .then(res => setActiveFY(res.data))
  //     .catch(() => setActiveFY(null))
  //     .finally(() => setLoadingFY(false));
  // }, []);

  return (
    <FinancialYearContext.Provider
        value={{ activeFY, loadingFY, financialYearError, refreshActiveFY }}
    >
      {children}
    </FinancialYearContext.Provider>
  );
};
